import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { trackLandingCta } from "../../hooks/useLandingAnalytics";

/** Compact closing CTA — same button pair as the hero (gradient primary +
 * ghost secondary), no duplicate capture forms. */
export function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section id="final-cta" className="relative scroll-mt-16 overflow-hidden border-t border-slate-200/80 bg-white py-16 dark:border-white/5 dark:bg-slate-950 sm:py-24">
      <div className="pointer-events-none absolute bottom-0 left-1/2 h-[20rem] w-[40rem] -translate-x-1/2 translate-y-1/3 rounded-full glow [--glow:color-mix(in_srgb,var(--accent-400)_10%,transparent)] dark:[--glow:color-mix(in_srgb,var(--accent-600)_15%,transparent)]" />
      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6">
        <span className="inline-flex rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-200 dark:bg-white/10 dark:text-blue-200 dark:ring-white/10">
          {t("landing.finalCta.eyebrow")}
        </span>
        <h2 className="mt-5 text-3xl font-bold leading-[1.1] tracking-tight text-slate-900 dark:text-white sm:text-5xl">
          {t("landing.finalCta.title")}{" "}
          <span className="bg-gradient-to-r from-blue-600 via-indigo-500 to-violet-600 bg-clip-text text-transparent dark:from-blue-400 dark:via-indigo-400 dark:to-violet-400">
            {t("landing.finalCta.titleLine2")}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate-600 dark:text-slate-400 sm:text-base">
          {t("landing.finalCta.subtitle")}
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/register?src=landing"
            onClick={() => trackLandingCta("final_cta_button", "final")}
            className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-blue-500/30 transition-all hover:shadow-blue-500/50 hover:from-blue-400 hover:to-indigo-500"
          >
            {t("landing.finalCta.button")}
            <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5" />
          </Link>
          <a
            href="mailto:sales@adambusinesshub.com"
            className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold text-slate-700 ring-1 ring-slate-300 transition-colors hover:bg-slate-50 hover:text-slate-900 dark:text-slate-200 dark:ring-white/15 dark:hover:bg-white/5 dark:hover:text-white"
          >
            {t("landing.finalCta.secondary")}
          </a>
        </div>
      </div>
    </section>
  );
}
